import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

import ComingSoon from "@/components/shared/ComingSoon"
import routes from "@/routes/routes"

/** Accounting while climate setup is not completed: the same screen as Scope 1 (MPE-1537). */
export const AccountingSetupLocked = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <ComingSoon
      title={t("comingSoonRoutes.accountingLocked.title")}
      description={t("comingSoonRoutes.accountingLocked.description")}
      notifyMeButtonText={t("comingSoonRoutes.scope1.cta")}
      onNotifyMeButtonClick={() => navigate(routes.climateSetup)}
    />
  )
}
